<template>
    <div class="mapStatistics">
      <div class="card-panel-icon-wrapper" style="position:absolute;z-index: 10000;right:50%;top:0px;font-size:25px;" @click="toggleHead">
           <span v-if="down"><svg-icon icon-class="up" class-name="up-down" /></span>
           <span v-if="!down"><svg-icon icon-class="down" class-name="up-down" /></span>
      </div>
      <el-row :gutter="32" class="search-wrap" :class="{ 'heaad-down': !down }">
        <div class="head-content">
          <el-col :xs="24" :sm="24" :lg="14" class="logo-wrapper">
          <img
          style="width: 52px; height: 40px;margin-right: 10px;"
          src="../../assets/wlLogo.png"
          />
          <h1 class="logo-title">智分瓦力可视化智慧物流平台</h1></el-col>
        <el-col :lg="4">
          <!-- <el-select v-model="type" placeholder="订单视角" class="select" @change="searchFn">
            <el-option
              v-for="item in searchOptions"
              :key="item.id"
              :label="item.label"
              :value="item.id">
           </el-option>
          </el-select> -->
          <!-- <i class="el-icon-view"></i> -->
          <div class="tag">地理围栏</div>
          <el-button @click="refresh">刷新</el-button>
          
        </el-col>
        <el-col :lg="5">
          <div class="title">{{timeString}}</div>
          <div class="text">[高丽营]片区</div>
        </el-col>
        </div>
       
      </el-row>
      <div id="mapContainer" style="width: 100%;" ref="map">
        <div class="card-panel-icon-wrapper" style="position:absolute;z-index: 10000;right:10px;top:72px;font-size:25px;" @click="toggleMapTip">
           <span v-if="foldUp"><svg-icon icon-class="dakai" class-name="card-panel-icon" /></span>
           <span v-if="!foldUp"><svg-icon icon-class="shouqi" class-name="card-panel-icon" /></span>
        </div>
       
           <div class="showData-wrap" :class="{ 'offset-class': foldUp }"> 
               <div class="content-wrap">  
                 <div class="card">  
                   <div class="card-wrap">  
                     <div class="img-wrap">  
                         <div></div>  
                     </div>   
                       <div class="content">  
                         <p><span>0</span>次</p>  
                         <p>请求支援</p>  
                     </div>  
                   </div>  
                 </div>  
                 <div class="card">  
                   <div class="card-wrap">  
                     <div class="img-wrap">  
                         <div></div>  
                     </div>   
                       <div class="content">  
                         <p><span>0</span>人</p>  
                         <p>掉线提醒</p>  
                     </div>  
                   </div>  
                 </div>  
                 <div class="card">  
                   <div class="card-wrap">  
                     <div class="img-wrap">  
                         <div></div>  
                     </div>   
                       <div class="content">  
                         <p><span>0</span>次</p>  
                         <p>催单提醒</p>  
                     </div>  
                   </div>  
                 </div>  
                 <div class="card">  
                   <div class="card-wrap">  
                     <div class="img-wrap">  
                         <div></div>  
                     </div>   
                       <div class="content">  
                         <p><span>{{orderNums}}</span>个</p>  
                         <p>超时订单</p>  
                     </div>  
                   </div>  
                 </div>  
               </div>  
             </div>
       
      </div>
    </div>
  </template>
  
  <script>
  import AMapLoader from "@amap/amap-jsapi-loader";
  import { glyMapData,glylxhyMapData,glyxyzyMapData,glylxnyMapData,glywwsMapData,glyxsjlzMapData,glygchysyMapData,glygcbsMapData,glyflskshgjMapData,glyflskjxptMapData,glyxxyMapData,glyschyMapData } from "../../utils/mapData";
  import {getCarGpsList, getCleanCarGpsList,getGarbagePointList,getRecyclerGpsList,getTimeOutOrderNums} from '@/api/visualization'
  
  window._AMapSecurityConfig = {
    securityJsCode: "8e9c248f99df3ed6ea243177e37306d1", // 安全密钥
  };
  let AMap = null;
  export default {
    name: "MapStatistics",
    components: { },
    data() {
        return {
          map: null,
          mapInstance: null,
          AMap: null,
          icon: null,
          type: undefined,
          foldUp: false,
          down: true,
          searchOptions: [
          {id: 1, label: '驿站'},
          {id: 2, label: '快递车'},
          {id: 3, label: '送货员'},
          ],
          dataList:[],
          timeString:'',
          orderNums:undefined
        }
    },
    watch: {
    },
    created() {},
    mounted() {
      setInterval(this.updateTime, 1000);
      this.initMap();
      this.getTimeOutOrderNums();
      // setInterval(this.initData().then(()=>{
      //   this.initData();
      // }), 600000);
    },
    destroyed() {},
    methods: {
      initData() {
        return Promise.all([this.getRecyclerGpsList(),this.getCarGpsList(),this.getCleanCarGpsList(),this.getGarbagePointList()]).then(([res1,res2,res3,res4])=>{
          
            res1 = [{
              "type": 1,
              "imageUrl": "https://dev-wali.oss-cn-beijing.aliyuncs.com/inspectionUser/recyclerZJB.png",
              "avatar": "https://dev-wali.oss-cn-beijing.aliyuncs.com/inspectionUser/recyclerZJB.png",
              "latitude": 40.15788668,
              "longitude": 116.55218465
            }];

            res2 = [{
              "type": 2,
              "imageUrl": "https://dev-wali.oss-cn-beijing.aliyuncs.com/inspectionUser/recycleCar.png",
              "latitude": 40.15799241,
              "longitude": 116.55177688
            }];

            res3 = [{
              "type": 3,
              "imageUrl": "https://dev-wali.oss-cn-beijing.aliyuncs.com/inspectionUser/cleanCar.png",
              "latitude": 40.13562912,
              "longitude": 116.49765515
            }];
          //  if(res1){
//  res1.forEach((item)=>{
//  item.type = 1;
//  item.imageUrl = 'https://dev-wali.oss-cn-beijing.aliyuncs.com/inspectionUser/recyclerSYJ.png';       })
//  } else {
//  res1 = [];
//  }
//  if(res2) {
//  res2.forEach((item)=>{
//  item.type = 2;
//  item.imageUrl = 'https://dev-wali.oss-cn-beijing.aliyuncs.com/inspectionUser/recycleCar.png';       })
//  } else {
//  res2 = [];
//  }
//
//  if(res3){
//  res3.forEach((item)=>{
//  item.type = 3;
//  item.imageUrl = 'https://dev-wali.oss-cn-beijing.aliyuncs.com/inspectionUser/cleanCar.png';       })
//  } else {
//  res3 = [];
//  }
//  if(res4) {
//  res4.forEach((item)=>{
//  item.type = 4;
//  item.imageUrl = 'https://dev-wali.oss-cn-beijing.aliyuncs.com/inspectionUser/recycleHouse.png';       })
//  } else {
//  res4 = [];
//  }
          const locationsToConvert = [...res1,...res2,...res3];
          //const otherLocations = res4;
           // 处理需要转换的坐标
          this.addMarkers(locationsToConvert);
          // 直接添加无需转换的其他坐标
          //this.addMarkers(otherLocations);

  
      })
      },
      // 初始化地图
    initMap() {
      if (this.mapInstance) return this.mapInstance;
      return AMapLoader.load({
        key: "c98add164435e1dd4beff2d292a4fffb", // 申请好的Web端开发者Key，首次调用 load 时必填
        // key: "5e8d33843fc45ecb10667ac5aeb46af1",
        version: "2.0",
        plugins: ["AMap.convertFrom",'AMap.Map', 'AMap.Marker'],
      })
        .then((aMap) => {
          AMap = aMap;
          this.mapInstance = new AMap.Map("mapContainer", {
            zoom: 13.4,
            center: [116.53592139, 40.15861661],
            mapStyle: "amap://styles/darkblue",
            resizeEnable: true,
           });

          var path = glyMapData;
          // 创建多边形
          var polygon = new AMap.Polygon({
              path: path,
              fillColor: '#4b6cb7', // 填充颜色
              borderWeight: 1,      // 线条宽度，默认为 1
              strokeColor: '#0C387AFF' // 线条颜色
          });
          this.mapInstance.add(polygon);

          var lxhypath = glylxhyMapData;
          // 创建多边形
          var lxhypolygon = new AMap.Polygon({
              path: lxhypath,
              fillColor: '#00ff0dff', // 填充颜色
              borderWeight: 1,      // 线条宽度，默认为 1
              strokeColor: '#00ff0dff' // 线条颜色
          });
          this.mapInstance.add(lxhypolygon);

          var xyzypath = glyxyzyMapData;
          // 创建多边形
          var xyzypolygon = new AMap.Polygon({
              path: xyzypath,
              fillColor: '#00ff0dff', // 填充颜色
              borderWeight: 1,      // 线条宽度，默认为 1
              strokeColor: '#00ff0dff' // 线条颜色
          });
          this.mapInstance.add(xyzypolygon);

          var lxnypath = glylxnyMapData;
          // 创建多边形
          var lxnypolygon = new AMap.Polygon({
              path: lxnypath,
              fillColor: '#0b37fcff', // 填充颜色
              borderWeight: 1,      // 线条宽度，默认为 1
              strokeColor: '#0b37fcff' // 线条颜色
          });
          this.mapInstance.add(lxnypolygon);

          var wwspath = glywwsMapData;
          // 创建多边形
          var wwspolygon = new AMap.Polygon({
              path: wwspath,
              fillColor: '#0b37fcff', // 填充颜色
              borderWeight: 1,      // 线条宽度，默认为 1
              strokeColor: '#0b37fcff' // 线条颜色
          });
          this.mapInstance.add(wwspolygon);

          var sjlzpath = glyxsjlzMapData;
          // 创建多边形
          var sjlzpolygon = new AMap.Polygon({
              path: sjlzpath,
              fillColor: '#0b37fcff', // 填充颜色
              borderWeight: 1,      // 线条宽度，默认为 1
              strokeColor: '#0b37fcff' // 线条颜色
          });
          this.mapInstance.add(sjlzpolygon);

          var gchysypath = glygchysyMapData;
          // 创建多边形
          var gchysypolygon = new AMap.Polygon({
              path: gchysypath,
              fillColor: '#0b37fcff', // 填充颜色
              borderWeight: 1,      // 线条宽度，默认为 1
              strokeColor: '#0b37fcff' // 线条颜色
          });
          this.mapInstance.add(gchysypolygon);

          var gcbspath = glygcbsMapData;
          // 创建多边形
          var gcbspolygon = new AMap.Polygon({
              path: gcbspath,
              fillColor: '#0b37fcff', // 填充颜色
              borderWeight: 1,      // 线条宽度，默认为 1
              strokeColor: '#0b37fcff' // 线条颜色
          });
          this.mapInstance.add(gcbspolygon);

          var flskshgjpath = glyflskshgjMapData;
          // 创建多边形
          var flskshgjpolygon = new AMap.Polygon({
              path: flskshgjpath,
              fillColor: '#0b37fcff', // 填充颜色
              borderWeight: 1,      // 线条宽度，默认为 1
              strokeColor: '#0b37fcff' // 线条颜色
          });
          this.mapInstance.add(flskshgjpolygon);

          var flskjxptpath = glyflskjxptMapData;
          // 创建多边形
          var flskjxptpolygon = new AMap.Polygon({
              path: flskjxptpath,
              fillColor: '#0b37fcff', // 填充颜色
              borderWeight: 1,      // 线条宽度，默认为 1
              strokeColor: '#0b37fcff' // 线条颜色
          });
          this.mapInstance.add(flskjxptpolygon);

          var xxypath = glyxxyMapData;
          // 创建多边形
          var xxypolygon = new AMap.Polygon({
              path: xxypath,
              fillColor: '#0b37fcff', // 填充颜色
              borderWeight: 1,      // 线条宽度，默认为 1
              strokeColor: '#0b37fcff' // 线条颜色
          });
          this.mapInstance.add(xxypolygon);
          
          var schypath = glyschyMapData;
          // 创建多边形
          var schypolygon = new AMap.Polygon({
              path: schypath,
              fillColor: '#0b37fcff', // 填充颜色
              borderWeight: 1,      // 线条宽度，默认为 1
              strokeColor: '#0b37fcff' // 线条颜色
          });
          this.mapInstance.add(schypolygon);

            this.initData()
        })
        .catch((e) => {
          console.log(e);
        });
      },
      refresh() {
        this.initData();
    },
    addCustomMarker(position, markerData) {
      var customContent = document.createElement('div');
          customContent.style.cssText = 'position:reletive'; 
        if (markerData.type !== 1) {
          var contentWrapCar= document.createElement('div');
          contentWrapCar.style.cssText = 'diaply:flex;align-items:center;';
          var imgCar = document.createElement('img');
          imgCar.src = markerData.imageUrl;
          imgCar.style.cssText = 'position:absolute; left:-20px;top:-9px;width:26px;height:26px; border:1px solid #E1E6E6; border-radius:23px';
          contentWrapCar.appendChild(imgCar.cloneNode(true));
          customContent.appendChild(contentWrapCar.cloneNode(true));
        } else {
          var contentWrap = document.createElement('div');
          contentWrap.style.cssText = 'diaply:flex;align-items:center;padding:5px 10px 5px 34px;width:160px;height: 32px; border-radius: 6px;';
          var imgUser = document.createElement('img');
          imgUser.src = markerData.avatar;
          imgUser.style.cssText = 'position:absolute; left:-20px;top:2px;width:26px;height:26px;z-index:10000;border:1px solid #E1E6E6;border-radius:13px; background-color:darkgoldenrod;';
          //var text = document.createElement('span');
         // text.style.cssText = 'display:block; height:100%;line-height:20px';
          //const account = markerData.recycleWeight ? markerData.recycleWeight: 0;
          //.textContent = `${markerData.deviceName}${account}kg `;
          contentWrap.appendChild(imgUser.cloneNode(true));
          //contentWrap.appendChild(text.cloneNode(true));
          customContent.appendChild(contentWrap.cloneNode(true));
        }
      
      const marker = new AMap.Marker({
        position: position,
        content: customContent,
        offset: new AMap.Pixel(-10, -30) // 可根据标签尺寸调整位置
      });
      marker.setMap(this.mapInstance);
    },
    convertAndAddMarkers(locations) {
      locations.forEach((location)=> {
        AMap.convertFrom([location.longitude, location.latitude], 'gps', (status, result) => {
          if (status === 'complete' && result.info === 'ok') {
            this.addCustomMarker(result.locations[0], location);
          } else {
            this.addCustomMarker([location.longitude, location.latitude], location);
          }
        });
      });
   },
   addMarkers(locations) {
    locations.forEach(location => {
      this.addCustomMarker([location.longitude, location.latitude], location);
    });
 },

    updateTime() {
      var now = new Date();
      var year = now.getFullYear();
      var month = (now.getMonth() + 1).toString().padStart(2, '0');
      var day = now.getDate().toString().padStart(2, '0');
      var hours = now.getHours().toString().padStart(2, '0');
      var minutes = now.getMinutes().toString().padStart(2, '0');
      var seconds = now.getSeconds().toString().padStart(2, '0');
      this.timeString = `${year}-${month}-${day}  ${hours}:${minutes}:${seconds}`;
    },
    toggleMapTip() {
      this.foldUp = !this.foldUp;
      if(this.foldUp) {
        this.$nextTick(() => {
          const parent = this.$refs['map'];
          const dynamicElement = parent.querySelector('maptip');
          if (dynamicElement) {
            dynamicElement.classList.add('offset-class');
          }
        });
      }
    },
    toggleHead() {
      this.down = !this.down;
    },
    getCarGpsList(){
      return getCarGpsList().then((res)=>{
        return res.data;
      });
     },
     getCleanCarGpsList(){
      return getCleanCarGpsList().then((res)=>{
        return res.data;
      });
     },
     getGarbagePointList(){
      return getGarbagePointList().then((res)=>{
        return res.data;
      });
     },
     getRecyclerGpsList(){
      return getRecyclerGpsList().then((res)=>{
        return res.data;
      });
     },
     getTimeOutOrderNums() {
      getTimeOutOrderNums().then((res)=>{
        this.orderNums = res.data;
      });
    }
    },
    
     
  };
  </script>
  
  <style rel="stylesheet/scss" lang="scss">
  .mapStatistics {
    background: #383A61FF;
    color:#E1E6E6;
    display: flex;
    flex-direction: column;
    height: 100vh;
    .logo-wrapper{
        display: flex;
        justify-content: start;
        align-items: center;
      }
    .logo-title {
      display: inline-block;
    }
    .text {
      color:darkgoldenrod;
    }
    #mapContainer {
      flex-grow: 1;
    }
    .tag {
      width: 180px;
      padding: 10px 20px;
      display: inline-block;
      background-color: rgb(18,33,117);
      text-align: center;
      
    }
    .el-button {
      background-color: rgb(18,33,117);
      margin: 0 10px;
      color:#E1E6E6;
    }
    .tag::before {
      content: '';
      display: inline-block;
      width: 12px;
      height: 12px;
      border: 2px solid #E1E6E6;
      border-radius: 1px;
      margin-right: 5px;
    }
  }
  .amap-logo {
    display: none;
  }
  .amap-copyright {
    opacity:0;
}
.search-wrap {
  max-height: 1000px; /* 设置一个足够大的值，以适应元素内容撑开的最大高度 */
  overflow: hidden;
  transition: max - height 0.5s ease;
  .select {
    margin-right: 20px;
  }
  .el-col:nth-child(2) {
    padding-top:20px;
    position: relative;
    .el-input__inner {
      width: 180px;
      background-color: rgb(18,33,117) !important;
      border: none !important;
      color:#E1E6E6;
      padding-left: 60px;
    }
    .el-icon-view {
      position: absolute;
      left: 40px;
      top:32px
    }
  }
  .el-col:nth-child(3) {
    padding-top:20px;
    text-align: right;
    padding-right: 50px !important;
  }
}
.head-content {
  padding: 10px 20px;
}
.heaad-down{
  max-height: 0px;
}
.showData-wrap {
  background: #242b6e;
  border-radius: 4px;
  position:absolute;
  top:40px;
  right: 40px;
  transition: right 0.5s ease;
  z-index: 1000;
  .content-wrap {
    padding: 10px;
    display: flex;
  }
  .card {
    align-content: center;
    background-color: rgb(18,33,117);
    margin: 0 5px;
    height: 60px;
    border-radius: 2px;
  }
  .img-wrap {
    display: flex;
    align-items: center;
    margin-right: 2px;
    div {
      width: 35px;
      height: 35px;
      background-repeat: no-repeat;
      background-position: center center;
    }
  }
  .card:nth-of-type(1) .img-wrap{
    div {
      background-image: url('../../assets/icon/love.png');
    }
  }
  .card:nth-of-type(2) .img-wrap{
    div {
      background-image: url('../../assets/icon/lixin.png');
    }
  }
  .card:nth-of-type(3) .img-wrap{
    div {
      background-image: url('../../assets/icon/dingdan.png');
    }
  }
  .card:nth-of-type(4) .img-wrap{
    div {
      background-image: url('../../assets/icon/chaoshi.png');
    }
  }
  .card-wrap {
    display: flex;
    padding:0 10px;
  }
  .content {
    p {
      line-height: 16px;
      font-size: 12px;
      padding: 2px;
      margin: 0;
      span {
        font-size:16px;
        font-weight: 600;
      }
    }
  }
  .tag-wrap {
    height: 40px;
    text-align: center;
    background-color: #242b6e;
  }
  .car {
    background: url('../../assets/logo.png');
    background-repeat: no-repeat;
    background-position: center;
  }
  .amap-info-window {
    background: transparent !important;
  }
  .amap-info-content {
    background: transparent !important;
  }
  .card-panel-icon {
    font-size: 48px;
  }
}
.offset-class {
    right: -498px;
  }
  .up-down {
    font-size: 20px;
  }
  
  </style>
  